export const archivePath = {
  /* inject path */
  GROUPS_TABLE: '/archive/groups-table',
  ADD_ITEM: '/archive/add-item',
  EDIT_ITEM: '/archive/edit-item/:id',
  EDIT_ITEM_URI: '/archive/edit-item',
  COPY_ITEM: '/archive/copy-item/:id',
  COPY_ITEM_URI: '/archive/copy-item',
  ADD_ITEM_URI: '/archive/add-item',
  ARCHIVE_DETAILS: '/archive/archive-details/:id',
  ARCHIVE_DETAILS_URI: '/archive/archive-details',
  CATEGORIES: '/archive/categories',
  TAGS_TABLE: '/archive/tags-table',
  ITEMS_TABLE: '/archive/items-table',
  DASHBOARD: '/archive/dashboard',
  MAIN: '/archive/main',
};
